export default {
  ListTab: {
    GeneralInfo: "Thông tin chung",
    ListAsset: "Danh sách tài sản",
  },
  TapGeneralInfo: {
    Reason: "Nội dung",
    ScheduleType: "Loại",
    Provider: "Nhà cung cấp",
    BeginDate: "Ngày thực hiện",
    FinishDate: "Ngày hoàn thành",
    Quantity: "Số lượng",
    ExpectedCost: "Chi phí dự kiến",
    Status: "Trạng thái",
  },
  TabListAsset: {
    ButtonAddAsset: "Thêm tài sản",
  },
  TitleFormAdd: "Thêm lịch sửa chữa - bảo dưỡng",
  ValidDeleteProcess: "Lịch đang thực hiện bạn không được phép xóa.",
  ValidDeleteDone: "Lịch đã hoàn thành bạn không được phép xóa.",
  TitleExport: "Lịch sửa chữa-bảo dưỡng",
};
